import React, { FC } from 'react'
import Box from '@components/Box'
import {
  SAddress,
  SAddressContainer,
  SAddressesContainer,
  SAddressTitle,
  SButton,
  SCard,
  SOpeningHours,
  SText,
} from '@components/WhereToApply/SComponents'
import LogoContainer from '@components/WhereToApply/LogoContainer'

const WhereToApply: FC = () => {
  return (
    <Box display="flex" flexDirection={{ _: 'column', xl: 'row' }} mt={{ _: '28px', md: '20px', xl: '32px' }}>
      <SCard>
        <LogoContainer title="Онлайн на сайте" />
        <SText>Оформление договора на сайте займет не более 2-х минут</SText>
        <SButton
          href="https://npo.npfsb.ru/?uniguid=AF2072&utm_source=sbernpfsite&utm_medium=lpdzo&utm_campaign=getkppcontract"
          link
          target="_blank"
        >
          Оформить договор
        </SButton>
      </SCard>
      <SCard>
        <LogoContainer title="В офисах" />
        <SAddressesContainer>
          <SAddressContainer>
            <SAddressTitle>ЦПАП</SAddressTitle>
            <SAddress>Московская область, ГО Химки, ул. Авиационная, корп. 6</SAddress>
            <SOpeningHours>СР с 9:00 до 18:00</SOpeningHours>
          </SAddressContainer>
          <SAddressContainer>
            <SAddressTitle>Мелькисарово</SAddressTitle>
            <SAddress>г. Москва, Международное ш., 31, с1</SAddress>
            <SOpeningHours>Вт с 9:00 до 18:00</SOpeningHours>
          </SAddressContainer>
        </SAddressesContainer>
      </SCard>
    </Box>
  )
}

export default WhereToApply
